import { UseQueryResult } from '@tanstack/react-query'
import useApi, { type ResponseError } from '@/api/base/useApi'
import { Company } from '@/types'

async function fetchCompanies(accessToken: string | undefined, userId: string | undefined): Promise<Company[]> {
  const url = `${process.env['NEXT_PUBLIC_API_ENDPOINT']}companies/`

  if (!accessToken) {
    return Promise.reject('No access token (fetchCompanies).')
  }

  const requestHeaders: any = {
    Authorization: 'Bearer ' + accessToken,
    'auth0-user-id': userId,
  }
  const response = await fetch(url, {
    method: 'GET',
    headers: requestHeaders,
  })

  if (response.status !== 200) {
    const json: ResponseError = await response.json()
    console.log('[admin/fetchCompanies] Error', response)
    return Promise.reject(json)
  }

  return response.json()
}

const useCompaniesQueryV1 = (enabled?: boolean): UseQueryResult<Company[], any> =>
  useApi(['companies'], fetchCompanies, {}, enabled)

export default useCompaniesQueryV1
